import React from 'react';

import { NumeralDisplay } from '../../Fields';
import { NumericalReadOnlyViewProps } from '../types';

export const TotalLoanAmountReadOnlyView = (props: NumericalReadOnlyViewProps) => (
  <NumeralDisplay title="Total loan amount" before="$" value={props.value} />
);
